import { CapData, VaultNode } from "./types";

export const borrowedUsd = (status: VaultNode["status"]): bigint =>
  status.utilizationRatio > 0n
    ? (status.valueUsd * status.utilizationRatio) / 10n ** 12n
    : 0n;

export const capPercent = (cap: CapData | undefined): number =>
  cap && cap.limit > 0n ? Number((cap.current * 10000n) / cap.limit) / 100 : 0;
